import { indicator } from "react-stockcharts";

var { defaultOptions } = indicator;

export default {
	...defaultOptions,
	FullStochasticOscillator: {
		...defaultOptions.FullStochasticOscillator,
		stroke: { D: "#ea2bff", K: "#74d400" }
	},
	MACD: {
		...defaultOptions.MACD,
		stroke: { MACDLine: "#ea2bff", signalLine: "#74d400", histogram: "#FF6600" },
		fill: { histogram: "#FF6600" },
	}
};


/** WEBPACK FOOTER **
 ** ./src/scripts/constants/customizedIndicatorOptions.js
 **/